/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_importBeneficiaryTravelDataResponse } from '../models/api_importBeneficiaryTravelDataResponse';
import type { db_GetTravelProviderDetailsRow } from '../models/db_GetTravelProviderDetailsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TravelProvider {
    /**
     * Export beneficiary travel data
     * @returns binary OK
     * @throws ApiError
     */
    public static exportBeneficiaryTravelData(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/travel-provider',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Import beneficiary travel data
     * @param file CSV file to be imported
     * @returns api_importBeneficiaryTravelDataResponse OK
     * @throws ApiError
     */
    public static importBeneficiaryTravelData(
        file: Blob,
    ): CancelablePromise<api_importBeneficiaryTravelDataResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/travel-provider',
            formData: {
                'file': file,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get travel provider details
     * @returns db_GetTravelProviderDetailsRow OK
     * @throws ApiError
     */
    public static getTravelProviderDetails(): CancelablePromise<db_GetTravelProviderDetailsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/travel-provider/details',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
